import api from "./api";

/**
 * Generative AI features (Claude on Amazon Bedrock, via the backend).
 * The backend resolves names and recognition types within the caller's
 * organization and writes in the caller's language.
 */
const aiService = {
  /** -> { enabled } */
  getStatus: async () => {
    const response = await api.get("/api/v1/ai/status");
    return response.data;
  },

  /** -> { message } (plain text; paragraphs separated by blank lines) */
  composeRecognition: async ({ recipientIds, recognitionTypeId, notes, tone }) => {
    const response = await api.post("/api/v1/ai/compose-recognition", {
      recipient_ids: recipientIds,
      recognition_type_id: recognitionTypeId || null,
      notes,
      tone,
    });
    return response.data;
  },
};

export default aiService;
